import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "61",
  fill: "none",
  viewBox: "0 0 60 61"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "M2.91 1.5h38.18c1.05 0 1.91.86 1.91 1.91v38.18c0 1.05-.86 1.91-1.91 1.91H2.91C1.86 43.5 1 42.64 1 41.59V3.41c0-1.05.86-1.91 1.91-1.91Z" }),
      _createElementVNode("path", { d: "m51 16.5 6.65 2.53a1.84 1.84 0 0 1 1.25 2.36L46.15 58.18a1.94 1.94 0 0 1-2.45 1.22L22 51.5" }),
      _createElementVNode("path", { d: "M14.81 13.55s-.41 10.49-3.9 12.98l6.08.86c.54.08 1.08.37 1.08.64s-.48.71-.96.98l-10.1 5.51v2c0 .55.45 1 1 1h27.94c.55 0 1-.45 1-1v-2l-10.1-5.51c-.48-.26-.96-.7-.96-.98s.53-.56 1.08-.64l6.08-.86c-3.49-2.49-3.9-12.98-3.9-12.98M29.13 13.55c-.59-3.4-3.57-5.98-7.16-5.98-3.59 0-6.57 2.59-7.16 5.98" })
    ], -1)
  ])))
}
export default { render: render }